import { useQueryClient } from "@tanstack/react-query";
import { $api } from "../generated/client";

const GIFT_CODES_PATH_PREFIX = "/shops/{shopId}/gift-codes";

/** Finds an order by name, with the code each line item already has. */
export function useGiftCodeOrderLookup() {
  return $api.useMutation("get", "/shops/{shopId}/gift-codes/order-lookup");
}

/**
 * Issues the gift code of one line item (or returns the existing one), then
 * refreshes the gift code list and stats.
 */
export function useIssueGiftCode() {
  const queryClient = useQueryClient();

  return $api.useMutation("post", "/shops/{shopId}/gift-codes", {
    onSuccess: () =>
      queryClient.invalidateQueries({
        predicate: ({ queryKey }) =>
          typeof queryKey[1] === "string" &&
          queryKey[1].startsWith(GIFT_CODES_PATH_PREFIX),
      }),
  });
}
